module.exports = __webpack_public_path__ + "img/isklattring.9ce8c35f.jpg";